module.exports = __webpack_public_path__ + "static/media/beach.b539597b.jpg";